function isPrivateIpv4(ip: string) {
  const ipv4Pattern = /^(\d{1,3}\.){3}\d{1,3}$/;
  if (!ipv4Pattern.test(ip)) return false;

  const parts = ip.split('.')
    .map((part: string) => parseInt(part, 10));

  if (parts[0] === 10) {
    return parts[1] >= 0 && parts[1] <= 255 && parts[2] >= 0 && parts[2] <= 255 && parts[3] >= 0 && parts[3] <= 255;
  } else if (parts[0] === 172) {
    return parts[1] >= 16 && parts[1] <= 31 && parts[2] >= 0 && parts[2] <= 255 && parts[3] >= 0 && parts[3] <= 255;
  } else if (parts[0] === 192) {
    return parts[1] === 168 && parts[2] >= 0 && parts[2] <= 255 && parts[3] >= 0 && parts[3] <= 255;
  } else {
    return false;
  }
}

export default isPrivateIpv4;
